import { render, staticRenderFns } from "./CedTableRoulette.vue?vue&type=template&id=912f8d28"
import script from "./CedTableRoulette.vue?vue&type=script&lang=js"
export * from "./CedTableRoulette.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports